import $ from "jquery";


window.addEventListener('DOMContentLoaded', (event) => {
    if($('.active_section').length > 0){
        //console.log('adjust height: ')
        var section_height = $('.active_section').height() + 100 + 'px';
        console.log("section_height resize: " + section_height );
        jQuery('.tabanimationcontainer').animate({
            height: section_height
        }, 10);
    }
});

$(window).on('resize', function() {
    if($('.active_section').length > 0){
        //console.log('adjust height: ')
        var section_height = $('.active_section').height() + 100 + 'px';
        console.log("section_height resize: " + section_height );
        jQuery('.tabanimationcontainer').animate({
            height: section_height
        }, 10);
    }
});


jQuery('.taboption').click(function(event) {
    // get clicked tab id
var tabid = jQuery(event.target).attr('id')

//if it is the active tab to nothing
if (jQuery(event.target).hasClass('activetab')) {

} else {
    var currentActiveTab = jQuery('.activetab');
    currentActiveTab.removeClass('activetab');

    var newactiveTab = jQuery(event.target);
    newactiveTab.addClass('activetab');

    var animationContainer = $('.tabanimationcontainer');
    var tabContainer = $('.tabcontainer');

    animationContainer.animate({
        left: '-50px',
        opacity: 0
    }, 200, function() {
        tabContainer.hide();
        $('.active_section').removeClass('active_section');
        jQuery('.' + tabid).show().addClass('active_section');

        animationContainer.css('left', '50px');
        animationContainer.animate({
            left: '0px',
            opacity: 1
        }, 200, function() {

            console.log('adjust height: ')
            var section_height = $('.active_section').height() + 100 + 'px';
            console.log("section_height" + section_height );
            jQuery('.tabanimationcontainer').animate({
                height: section_height
            }, 400);

    
        });
    });

    // jQuery('.tabcontainer').hide();

    // jQuery('.tabanimationcontainer').animate({
    //     left: '50px'
    // }, 0);
    // jQuery('.' + tabid).animate({
    //     opacity: '1'
    // }, 200);
    // jQuery('.tabanimationcontainer').animate({
    //     left: '0px'
    // }, 200);




    

}
});